/* unplugin-vue-components disabled */import script from "./admin.vue?vue&type=script&setup=true&lang=ts"
export * from "./admin.vue?vue&type=script&setup=true&lang=ts"

import "./admin.vue?vue&type=style&index=0&id=232a2f93&lang=scss"

const __exports__ = script;

export default __exports__